module.exports = __webpack_public_path__ + "375050691e25eb887662b2aa9ec70aa4.svg";